/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when a given `<Typography />` prop has been used before a `variant` has been set
 * @export
 * @class I18nNotEmptyTypographPropError
 * @extends {Error}
 */
export class I18nNotEmptyTypographPropError extends Error {
  /**
   * Creates an instance of I18nNotEmptyTypographPropError
   * @param {string} message The Error `message`
   * @memberof I18nNotEmptyTypographPropError
   */
  constructor(message) {
    super(message);
    this.name = `I18nNotEmptyTypographPropError`;
  }
}

/**
 * Called when a given `<Typography />` prop has been used before a `variant` has been set
 * @param {string} key The `key` for the `<I18n />` component where the `prop` was used
 * @param {string} name The name of the `prop`
 * @param {any} prop The `prop` that was attempted to be set before declaring a `variant`
 * @returns {never} never
 */
const throwI18nNotEmptyTypographPropError = (key, name, prop) => {
  throw new I18nNotEmptyTypographPropError(
    stripIndent(`
    Could not set prop: "${name}" to "${prop}" without first declaring a "variant" on "<I18n>${key}</I18n>".
    `),
  );
};

export default throwI18nNotEmptyTypographPropError;
